<template>
  <div v-if="event && hasPaidTickets">

    <div class="row">

      <div class="col col-6">
        <div class="col col-12">
          <div class="card">
            <div class="card-header">
              Tickets
            </div>

            <div class="card-body">
              <div v-for="(ticket, index) in tickets" :key="index">
                <p v-if="eventBooking.early_bird_valid">{{ ticket.details }}: {{ ticket.quantity_tickets }} x £{{
                  parseFloat(ticket.cost_a).toFixed(2)}} = £{{ ticketCost(ticket) }}</p>
                <p v-else>{{ ticket.details }}: {{ ticket.quantity_tickets }} x £{{ parseFloat(ticket.cost_b).toFixed(2)
                  }} = £{{ ticketCost(ticket) }}</p>
              </div>
              <div v-if="eventDiscount">
                Event discount applied: £{{ eventDiscount.toFixed(2) }}
              </div>
            </div>

            <div class="card-footer">
              Subtotal: £{{ subtotal }}
            </div>
          </div>
        </div>

        <div class="col col-12">
          <div class="card">
            <div class="card-header">
              Have a discount code? Add it here
            </div>

            <div class="card-body">
              <el-input placeholder="Please input" v-model="discountCode">
                <el-button @click="applyDiscountCode" slot="append" icon="el-icon-plus"></el-button>
              </el-input>
            </div>
          </div>
        </div>
      </div>

      <div class="col col-6">
        <div v-if="subtotal > 0" class="card">
          <h5 class="card-header hg-underline">Please provide your payment details:</h5>
          <stripe-element-payment v-if="elementsOptions.clientSecret" class="card-body" ref="paymentRef" :pk="pk"
            :elements-options="elementsOptions" :confirm-params="confirmParams" :stripe-account="stripeConnectId"
            @error="handlePayError" @element-change="handleChange" />
          <div v-else-if="paymentError" class="card-body">
            <p class="text-danger">We couldn't load the payment form. {{ paymentError }}</p>
            <button class="btn btn-primary" @click="getPaymentIntent">Retry</button>
          </div>
          <div v-else class="card-body">
            <i class="fa fa-spinner fa-spin"></i> Loading payment&hellip;
          </div>
          <div class="card-footer">
            <button v-if="elementsOptions.clientSecret" :disabled="paymentSubmitted" @click="pay"
              class="btn btn-primary btn-lg">
              <div v-if="paymentSubmitted">
                <i class="fa fa-spinner fa-spin"></i>
                <br /> Please wait
              </div>
              <div v-else>Pay now</div>
            </button>
          </div>
        </div>

        <div v-else class="card">
          <h5 class="card-header hg-underline">Free Booking</h5>
          <p class="card-body">This booking is now free, please confirm your booking.</p>
          <div class="card-footer">
            <button @click="pay" class="btn btn-primary btn-lg">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { StripeElementPayment } from '@vue-stripe/vue-stripe';
import discountInput from './discount-input.vue';

export default {
  beforeRouteLeave(to, from, next) {
    debugger

    if (to.name == 'home') {
      if (confirm("Are you sure you want to leave this page, if you do it will take you to the start of the bookings process?")) {
        next(); // Allow navigation
        location.reload();
      } else {
        next(false); // Prevent navigation
      }
    }
    else {
      next(); // Allow navigation
    }

  },

  components: {
    StripeElementPayment,
    discountInput
  },

  mounted() {
    console.log('Payment component mounted');
    console.log('Event:', this.event);
    console.log('Has paid tickets:', this.hasPaidTickets);
    console.log('Event booking:', this.eventBooking);
    console.log('Tickets:', this.tickets);

    if (this.eventBooking && this.eventBooking.id) {
      this.getPaymentIntent()
    } else {
      console.warn('EventBooking not available in mounted hook');
    }
  },

  watch: {
    eventBooking: {
      handler(newVal) {
        console.log('EventBooking watcher triggered:', newVal);
        if (newVal && newVal.id && !this.paymentIntent) {
          console.log('Getting payment intent from watcher');
          this.getPaymentIntent()
        }
      },
      immediate: true
    }
  },

  data() {
    return {
      // tickets: this.$store.getters.getSelectedTickets,
      paymentIntent: null,
      paymentSubmitted: false,
      pk: window.stripePubKey,
      stripeConnectId: null,
      paymentType: 'card',
      creatingPaymentIntent: false,
      paymentError: null,
      elementsOptions: {
        hidePostalCode: true,
        appearance: {
          theme: 'flat',
          variables: {
            spacingUnit: '2px',
            borderRadius: '4px',
            // See all possible variables below
          }
        }, // appearance options
        clientSecret: null,
      },
      confirmParams: {
        return_url: window.location.href.replace('#/payment', '#/summary'),
      },
      discountCode: null,
      eventDiscount: 0
    }
  },

  methods: {
    handleChange(event) {
      // Allows us to set the payment type to be consumed by the summary page
      if (event.value.type == 'bacs_debit') {
        this.paymentType = 'bacs'
      } else {
        this.paymentType = 'card'
      }
    },

    getPaymentIntent() {
      console.log('getPaymentIntent called', this.eventBooking);
      if (!this.eventBooking || !this.eventBooking.id) {
        console.warn('EventBooking not available, cannot get payment intent');
        return;
      }

      self = this
      self.paymentError = null
      self.$http
        .get('/get_payment_intent/' + self.eventBooking.id)
        .then(function (response) {
          console.log('Payment intent response:', response.data);
          if (response.data.intent == null) {
            self.createPaymentIntent()
          }
          else {
            self.paymentIntent = response.data.intent
            self.stripeConnectId = response.data.connect_account_id;
            self.elementsOptions.clientSecret = self.paymentIntent.client_secret;
          }
        })
        .catch(function (error) {
          console.error('Error getting payment intent:', error);
          self.paymentError = error.response?.data?.error || error.message;
        });
    },

    createPaymentIntent() {
      console.log('createPaymentIntent called');
      if (this.creatingPaymentIntent) {
        console.log('Already creating payment intent, skipping...');
        return;
      }

      this.creatingPaymentIntent = true;
      self = this
      self.$http
        .post('/create_payment_intent/' + self.eventBooking.id)
        .then(function (response) {
          console.log('Payment intent created:', response.data);
          self.paymentIntent = response.data.intent
          self.stripeConnectId = response.data.connect_account_id;
          self.elementsOptions.clientSecret = self.paymentIntent.client_secret;
          console.log('Client secret set:', self.elementsOptions.clientSecret);
        })
        .catch(function (error) {
          console.error('Error creating payment intent:', error);
          self.paymentError = error.response?.data?.error || error.message;
          self.$notify.error({
            title: "Failed to create payment intent",
            message: error.response?.data?.error || error.message
          });
        })
        .finally(function() {
          self.creatingPaymentIntent = false;
        });
    },

    updatePaymentIntent() {
      self = this
      self.$http
        .put('/update_payment_intent/' + self.paymentIntent.id, { event_booking_id: self.eventBooking.id, amount: self.subtotal })
        .then(function (response) {
          self.paymentIntent = response.data.intent
        });
    },

    pay() {
      if (this.subtotal > 0) {
        this.paymentSubmitted = true
        // Sets the payment type to be consumed by the summary page
        this.$store.commit('setEventBookingPaymentType', this.paymentType);
        this.$refs.paymentRef.submit();
      }
      else {
        // go to summary
        self = this
        self.$http
          .put('/cancel_payment_intent/' + self.paymentIntent.id, { event_booking_id: self.eventBooking.id })
          .then(function (response) {
            self.paymentIntent = response.data.intent
            self.$http
              .put('/complete_booking/' + self.eventBooking.id)
              .then(function (response) {
                this.$router.push({ name: "summary" });
              });
          });
      }
    },

    handlePayError(error) {
      this.paymentSubmitted = false;
      self.$notify.error({
        title: "Failed",
        message: error.message
      });
    },

    ticketCost(ticket) {
      var cost = 0
      if (this.eventBooking.early_bird_valid) {
        cost = ticket.cost_a
      }
      else {
        cost = ticket.cost_b
      }
      return (ticket.quantity_tickets * cost).toFixed(2)
    },

    applyDiscountCode() {
      self = this
      this.$http
        .put('/discounts/' + self.event.id + '/apply_discount', { event_booking: self.eventBooking, code: self.discountCode, packages: self.tickets.map(x => x.id) })
        .then(function (response) {
          var details = response.data.discount_details
          var earlyBird = response.data.discount_details.early_bird

          // if discount is per ticket
          if (details.discount.event_or_ticket == true) {

            // find ticket stored against booking as opposed to one passed back from controller
            var ticket = self.tickets.find(t => t.id === details.ticket.id)
            if (ticket) {
              var cost = details.new_cost
              if (earlyBird) {
                ticket.cost_a = details.new_cost
              } else {
                ticket.cost_b = details.new_cost
              }
              self.$notify.success({
                title: "Code successfully applied",
                message: ticket.details + " new cost is: £" + parseFloat(cost).toFixed(2)
              });

              var pb_discount = response.data.discount_details.package_booking_discount

              self.$store.commit('setSelectedTickets', self.tickets)

              // Ensures discouts for package bookings are updated to eventbooking
              self.$store.commit('setPackageBookingDiscount', pb_discount)

              self.discountCode = null
            }
            else {
              self.$notify.error({
                title: "Error",
                message: 'This code does not apply to a ticket you have booked'
              });
            }
          }
          // if event ticket
          else {
            var eb_discount = response.data.discount_details.event_booking_discount
            self.$store.commit('setEventBookingDiscount', eb_discount)
            self.eventDiscount = ((self.subtotal / 100) * details.new_cost)
            self.$notify.success({
              title: "Code successfully applied",
              message: "Events new cost is: £" + self.subtotal
            });
          }
          if (self.subtotal > 0) {
            self.updatePaymentIntent()
          }
        })
        .catch(e => {
          self.$notify.error({
            title: "Failed",
            message: e.response.data.error
          });
        });
    }
  },

  computed: {
    ...mapGetters({
      hasPaidTickets: 'getChargeable',
      tickets: 'getSelectedTickets',
      event: 'getEvent',
      eventBooking: 'getEventBooking',
    }),

    subtotal: function () {
      let total = [];
      Object.entries(this.tickets).forEach(([key, val]) => {
        if (this.eventBooking.early_bird_valid) {
          total.push(val.quantity_tickets * val.cost_a)
        }
        else {
          total.push(val.quantity_tickets * val.cost_b)
        }
      });
      var subtotal = parseFloat(total.reduce(function (total, num) { return total + num }, 0));
      if (this.eventDiscount) {
        subtotal -= this.eventDiscount
      }
      return subtotal.toFixed(2);
    }
  }
}
</script>

<style scoped></style>
